import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Lines, Reveal } from "@/components/motion/Reveal";
import { Tiles } from "@/components/motion/Tiles";

export default function NotFound() {
  return (
    <>
      <Seo title="Pagina non trovata" description="La pagina che cerchi non esiste." />
      <section className="relative flex min-h-[100svh] items-center overflow-hidden bg-ink text-white grain" data-testid="not-found">
        <div className="absolute inset-0 blueprint opacity-50" />
        <div className="container-x relative">
          <p className="display text-[8rem] leading-none text-stroke sm:text-[14rem]">404</p>
          <Tiles count={9} size={10} className="mt-2" />
          <Lines inView={false} lines={["Questa pagina", "non è in cantiere."]} className="display mt-4 text-4xl sm:text-5xl lg:text-6xl" />
          <Reveal delay={0.4} className="mt-8">
            <Link to="/" className="btn-primary" data-testid="not-found-home">Torna alla home <ArrowRight className="h-4 w-4" /></Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
